import axios from '@/plugins/axios'

export function getUserRepaired(params = {}) {
  return axios.get('user_repaired', {
    params,
  })
}

export function getUserRepairedImg(params = {}) {
  return axios.get('user_repaired/img', {
    params,
  })
}
